class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle ? this.mainDetailsToggle.querySelector('summary') : null;
    this.closeTimer = null;
    this.hoverTimer = null;
    this.boundUpdateMegaMenuPosition = this.updateMegaMenuPosition.bind(this);

    if (!this.mainDetailsToggle || !this.summary) return;

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    window.addEventListener('resize', this.boundUpdateMegaMenuPosition);

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimer);
    clearTimeout(this.hoverTimer);
    window.removeEventListener('resize', this.boundUpdateMegaMenuPosition);
  }

  onMouseEnter() {
    if (!window.matchMedia('(hover: hover)').matches) return;

    clearTimeout(this.hoverTimer);
    clearTimeout(this.closeTimer);

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle && menu.mainDetailsToggle.open) {
        menu.close();
      }
    });

    if (this.mainDetailsToggle.classList.contains('is-closing')) {
      this.mainDetailsToggle.classList.remove('is-closing');
    }

    if (!this.mainDetailsToggle.open) {
      this.open();
    }
  }

  onMouseLeave() {
    if (!window.matchMedia('(hover: hover)').matches) return;

    clearTimeout(this.hoverTimer);
    this.hoverTimer = setTimeout(() => {
      if (this.mainDetailsToggle.open) {
        this.close();
      }
    }, 180);
  }

  open() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary?.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onToggle() {
    if (!this.header || !this.mainDetailsToggle) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.summary) {
      this.summary.setAttribute('aria-expanded', this.mainDetailsToggle.open ? 'true' : 'false');
    }
    if (this.mainDetailsToggle.open) this.updateMegaMenuPosition();

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onSummaryClick(event) {
    if (!this.mainDetailsToggle || !this.mainDetailsToggle.classList.contains('mega-menu')) return;
    if (!this.mainDetailsToggle.open || this.mainDetailsToggle.classList.contains('is-closing')) return;

    event.preventDefault();
    this.close();
  }

  updateMegaMenuPosition() {
    if (!this.mainDetailsToggle || !this.mainDetailsToggle.classList.contains('mega-menu')) return;
    if (!this.header || !this.summary) return;

    const label = this.summary.querySelector('span');
    const triggerLeft = (label || this.summary).getBoundingClientRect().left;
    const headerLeft = this.header.getBoundingClientRect().left;
    this.mainDetailsToggle.style.setProperty('--mega-menu-left', `${Math.max(0, Math.round(triggerLeft - headerLeft))}px`);
  }

  close() {
    if (!this.mainDetailsToggle || !this.mainDetailsToggle.open || this.mainDetailsToggle.classList.contains('is-closing')) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.mainDetailsToggle.removeAttribute('open');
      if (this.summary) this.summary.setAttribute('aria-expanded', 'false');
      if (this.header) this.header.preventHide = false;
      return;
    }

    this.mainDetailsToggle.classList.add('is-closing');
    if (this.summary) this.summary.setAttribute('aria-expanded', 'false');
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.classList.remove('is-closing');
      if (this.header) this.header.preventHide = false;
    }, 280);
  }
}

customElements.define('header-menu', HeaderMenu);
